import React from 'react'
import { graphql, Link, StaticQuery } from 'gatsby'
import BkgImg from 'gatsby-background-image'
// import TransitionLink from 'gatsby-plugin-transition-link'

import nextArticleStyles from './nextArticle.module.scss'

class NextArticle extends React.Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  clickLink = (e, callback) => {
    e.preventDefault()
    callback()
  }

  render() {
    const { endCountdown, next, timeLeft, timeTotal } = this.props

    return (
      <StaticQuery
        query={query}
        render={data => (
          <div className={nextArticleStyles.container}>
            <Link
              to={`/${next.slug}`}
              onClick={e => {
                this.clickLink(e, endCountdown)
              }}
            >
              <div className={nextArticleStyles.bkgImgContainer}>
                <BkgImg
                  className={nextArticleStyles.bkgImg}
                  fluid={next.cover_image.childImageSharp.fluid}
                />
              </div>
              <div
                className={`${nextArticleStyles.progressBar} ${timeLeft <
                  timeTotal && nextArticleStyles.progressBar__running}`}
                style={{ animationDuration: `${timeTotal}s` }}
              ></div>
              <h2 className={nextArticleStyles.h2}>
                <span className={nextArticleStyles.kicker}>
                  {data.site.siteMetadata.articleMetadata.nextChapterKicker}
                </span>
                <br />
                {next.title}
              </h2>
            </Link>
          </div>
        )}
      />
    )
  }
}

export default NextArticle

const query = graphql`
  query {
    site {
      siteMetadata {
        articleMetadata {
          nextChapterKicker
        }
      }
    }
  }
`
